var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 129,
    viewBox: "0 0 96 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11371 7.15179C3.11371 5.58801 4.38141 4.32031 5.94519 4.32031H26.8982C28.462 4.32031 29.7297 5.58801 29.7297 7.1518V49.3413C29.7297 50.9051 30.9974 52.1728 32.5612 52.1728H65.4062H89.1907C90.7545 52.1728 92.0222 53.4405 92.0222 55.0043V122.394C92.0222 123.957 90.7545 125.225 89.1907 125.225H68.2377C66.6739 125.225 65.4062 123.957 65.4062 122.394V81.6203C65.4062 80.0565 64.1385 78.7888 62.5747 78.7888H32.5612C30.9974 78.7888 29.7297 80.0565 29.7297 81.6203V122.535C29.7297 124.099 28.462 125.366 26.8982 125.366H5.94519C4.38141 125.366 3.11371 124.099 3.11371 122.535V7.15179Z",
    fill: "#131314"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.96384,
    cy: 4.89377,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.96384,
    cy: 124.666,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.96384,
    cy: 104.279,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.96384,
    cy: 83.8083,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.96384,
    cy: 67.7458,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.96384,
    cy: 41.4904,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.2566,
    cy: 124.666,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.2566,
    cy: 108.211,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8809,
    cy: 4.89377,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8809,
    cy: 23.3176,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8809,
    cy: 124.666,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.3794,
    cy: 124.589,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.3794,
    cy: 100.488,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.3794,
    cy: 52.4631,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.3794,
    cy: 78.5647,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.0879,
    cy: 52.4631,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.8103,
    cy: 52.4631,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.8159,
    cy: 77.946,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8809,
    cy: 52.4631,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8809,
    cy: 77.946,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8809,
    cy: 109.092,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.2566,
    cy: 77.946,
    r: 3.96408,
    fill: "#BBBBBB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.97939,
    y1: 3.23584,
    x2: 3.97939,
    y2: 125.865,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.8809,
    y1: 77.0967,
    x2: 28.8809,
    y2: 124.382,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28.8809,
    y1: 4.61084,
    x2: 28.8809,
    y2: 52.4629,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 91.3538,
    y1: 53.9048,
    x2: 91.3538,
    y2: 124.332,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 91.4568,
    y1: 52.4627,
    x2: 28.881,
    y2: 52.4627,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 66.2565,
    y1: 77.9461,
    x2: 28.8809,
    y2: 77.9461,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 29.1961,
    y1: 4.89388,
    x2: 3.39777,
    y2: 4.89388,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 27.182,
    y1: 124.595,
    x2: 6.79531,
    y2: 124.595,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 91.1735,
    y1: 124.595,
    x2: 66.2564,
    y2: 124.595,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 91.8885,
    y1: 126.268,
    x2: 65.7868,
    y2: 108.951,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 91.8208,
    y1: 99.3518,
    x2: 65.7192,
    y2: 78.0384,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 90.7789,
    y1: 79.4615,
    x2: 68.7187,
    y2: 53.007,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 92.0957,
    y1: 78.5061,
    x2: 66.046,
    y2: 108.237,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 91.6233,
    y1: 53.1835,
    x2: 51.6993,
    y2: 78.1006,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 44.0534,
    y1: 52.8939,
    x2: 29.0466,
    y2: 78.3773,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 28.493,
    y1: 109.806,
    x2: 4.42533,
    y2: 125.379,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 29.4936,
    y1: 77.9682,
    x2: 3.70162,
    y2: 104.835,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 29.3312,
    y1: 23.7273,
    x2: 3.51347,
    y2: 67.9173,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 28.5335,
    y1: 23.4176,
    x2: 3.28206,
    y2: 41.9183,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 28.8451,
    y1: 109.692,
    x2: 3.41349,
    y2: 84.1503,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 28.4794,
    y1: 53.1846,
    x2: 3.84547,
    y2: 68.4746,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 28.6344,
    y1: 23.9629,
    x2: 3.48595,
    y2: 3.90388,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 43.5563,
    y1: 52.1807,
    x2: 52.3339,
    y2: 77.0977,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 69.0845,
    y1: 52.5398,
    x2: 66.8193,
    y2: 77.4569,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 66.2566,
    y1: 78.5127,
    x2: 66.2566,
    y2: 124.383,
    stroke: "#BBBBBB",
    strokeWidth: 1.69889
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHicon);
export default __webpack_public_path__ + "static/media/H icon.6424da02dbc7e3278915d0a114a5c6ff.svg";
export { ForwardRef as ReactComponent };